import { forwardRef } from "react";

import { GuidedHighlightingSVG, Icon } from "@newsela/angelou";

const GuidedHighlightingIcon = forwardRef((props, ref, css = {}) => {
  return (
    <Icon ref={ref} SvgComponent={GuidedHighlightingSVG} {...props} css={css} />
  );
});

export default GuidedHighlightingIcon;
